import React from 'react';

const SIZE = {
  sm:  'h-7 px-2.5 text-[11.5px]',
  md:  'h-9 px-4 text-[12.5px]',
  lg:  'h-10 px-5 text-[13px]',
  icon: 'h-8 w-8',
};

const VARIANT = {
  primary:   'bg-primary text-white hover:bg-primary-dark',
  accent:    'bg-accent text-white hover:bg-[#E08500]',
  secondary: 'border border-slate-200 bg-white text-slate-700 hover:bg-slate-50',
  danger:    'border border-rose-200 bg-rose-50 text-rose-700 hover:bg-rose-100',
  ghost:     'text-slate-600 hover:bg-slate-100',
};

export function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  icon: Icon,
  iconRight: IconRight,
  children,
  className = '',
  ...props
}) {
  const base =
    'inline-flex items-center justify-center gap-1.5 rounded-md font-semibold transition focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-600 focus-visible:ring-offset-1';
  const disabledCls = disabled || loading ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer';

  return (
    <button
      disabled={disabled || loading}
      className={`${base} ${SIZE[size]} ${VARIANT[variant]} ${disabledCls} ${className}`}
      {...props}
    >
      {loading && (
        <svg className="animate-spin w-3.5 h-3.5" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" opacity=".3" />
          <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
        </svg>
      )}
      {!loading && Icon && <Icon size={14} strokeWidth={1.75} />}
      {children}
      {!loading && IconRight && <IconRight size={14} strokeWidth={1.75} />}
    </button>
  );
}

export function IconButton({ icon: Icon, variant = 'secondary', size = 'md', className = '', ...props }) {
  return (
    <button
      className={`${SIZE[size] || SIZE.md} grid place-items-center rounded-md transition
        ${VARIANT[variant]} ${className}`}
      {...props}
    >
      {Icon && <Icon size={16} strokeWidth={1.75} />}
    </button>
  );
}

export default Button;
